import React from 'react';
import { Link } from 'react-router-dom';

export const PropertyItem = ({ item }) => {
  return (
    <div className="col-xl-6 col-sm-6 col-12">
      <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
        <div className="product-img go-top">
          <Link to={`/product-details/${item.id}`}>
            <img src={`https://f3mw4bb5.directus.app/assets/${item.main_image_850x650}`} alt="#" />
          </Link>
        </div>
        <div className="product-info">
          <div className="product-badge">
            <ul>
              <li className="sale-badg">For Rent</li>
            </ul>
          </div>
          <h2 className="product-title go-top">
            <Link to={`/product-details/${item.id}`}>{item.name}</Link>
          </h2>
          <div className="product-img-location go-top">
            <ul>
              <li>
                <Link to={`/product-details/${item.id}`}><i className="flaticon-pin" /> {item.address}</Link>
              </li>
            </ul>
          </div>
          <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
            <li><span>{item.beds}</span>
              Bed
            </li>
            <li><span>{item.baths}</span>
              Bath
            </li>
            <li><span>{item.home_area} </span>
              Square Ft
            </li>
          </ul>
          {/* <div className="product-hover-action">
            <ul>
              <li>
                <a href="#" title="Quick View" data-bs-toggle="modal" data-bs-target="#quick_view_modal">
                  <i className="flaticon-expand" />
                </a>
              </li>
              <li>
                <a href="#" title="Wishlist" data-bs-toggle="modal" data-bs-target="#liton_wishlist_modal">
                  <i className="flaticon-heart-1" /></a>
              </li>
              <li className="go-top">
                <Link to="/product-details" title="Product Details">
                  <i className="flaticon-add" />
                </Link>
              </li>
            </ul>
          </div> */}
        </div>
        <div className="product-info-bottom">
          <div className="product-price">
            <span>${item.price}<label>/{item.rental_recurrence}</label></span>
          </div>
        </div>
      </div>
    </div>
  );
}